import { useApiQuery } from '../useApiQuery';
import { crewKeys } from '@/lib/queryKeys';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { CrewMemberListParams, CrewMemberListResponse } from '@/types/crew';

export function useCrewMembers(params: CrewMemberListParams = {}) {
  return useApiQuery<CrewMemberListResponse>({
    queryKey: crewKeys.list(params),
    queryFn: async () => {
      try {
        const data = await apiGet<Record<string, unknown>[]>(
          operationsClient,
          schedulerEndpoints.technicians(),
        );
        const technicians = Array.isArray(data) ? data : [];
        return {
          data: technicians.map((t) => ({
            id: String(t.id ?? ''),
            firstName: String(t.name ?? '').split(' ')[0] || '',
            lastName:
              String(t.name ?? '')
                .split(' ')
                .slice(1)
                .join(' ') || '',
            email: String(t.email ?? ''),
            phone: '',
            role: 'technician' as const,
            status: t.isActive ? ('active' as const) : ('inactive' as const),
            timezone: typeof t.timezone === 'string' ? t.timezone : undefined,
            skills: [],
            createdAt: String(t.createdAt ?? ''),
            updatedAt: String(t.updatedAt ?? ''),
          })),
          total: technicians.length,
          page: 1,
          limit: technicians.length,
        } as unknown as CrewMemberListResponse;
      } catch {
        return { data: [], total: 0, page: 1, limit: 25 } as unknown as CrewMemberListResponse;
      }
    },
    showErrorToast: false,
  });
}
